import styled from 'styled-components'

import { Table } from 'src/components/Ant'

export const WrapTable = styled(Table)`
  border-radius: 4px;
  margin: 0 16px 24px 16px;
`
